export default __webpack_public_path__ + "static/media/arctic-logo-white.6f9cfcb5.png";